<script lang="tsx" setup>
import { useRoute } from "vue-router"

import { getPage } from "@/composables/get-page"
import { setPage } from "@/composables/set-page"
import { getPageQuery } from "@/composables/use-page"

import { KirbyPageData } from "@/queries"
import Main from "@/components/Wrappers/Main.vue"

const route = useRoute()
const query = getPageQuery(route.path)
const page = await getPage<KirbyPageData>(query)
setPage(page)
</script>

<template>
  <Main>
    <div>{{ page }}</div>
  </Main>
</template>
